import axios, { type AxiosInstance } from 'axios'

import { API_URL } from '@/utils/constants'

/**
 * Bearer-authenticated client for the EMR professional API. Sanctum reads the
 * personal access token off the Authorization header, which the interceptor
 * plugin attaches — EMR creates no session for professionals, so there is no
 * cookie to send and no CSRF token to mirror.
 */
const http: AxiosInstance = axios.create({
  baseURL: API_URL.replace(/\/+$/, ''),
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export default http
